import { FC } from "react";

const Person: FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3337 13.9996V12.6663C13.3337 11.9591 13.0527 11.2808 12.5526 10.7807C12.0525 10.2806 11.3742 9.99963 10.667 9.99963H5.33366C4.62641 9.99963 3.94814 10.2806 3.44804 10.7807C2.94794 11.2808 2.66699 11.9591 2.66699 12.6663V13.9996"
        stroke="#080A25"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99967 7.33297C9.47243 7.33297 10.6663 6.13906 10.6663 4.6663C10.6663 3.19354 9.47243 1.99963 7.99967 1.99963C6.52692 1.99963 5.33301 3.19354 5.33301 4.6663C5.33301 6.13906 6.52692 7.33297 7.99967 7.33297Z"
        stroke="#080A25"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Person;
